module.exports = __WEBPACK_EXTERNAL_MODULE_bf3d__;